import { types } from './actions';
import { parseTimesheetKeyforUserId, parseTimesheetKeyforDate } from './utils';

const initialState = {
  currentTimesheetKey: null,
  currentTimesheetIsApproved: null,
  currentSupervisorId: 0,
  currentTimesheetForUserId: null,
  currentTimesheetDate: null,
  showTimeEntryModal: false,
  currentTimeEntry: null,
  modalIsCreateEdit: true,
  modalAPIErrorMessage: '',
  showGuaranteedTimeModal: false,
  maybeApprovedTimesheet: null,
  disableApproveUnapproveButton: false,
  disableApproveUnapproveButtonForId: null,
  maxEditDate: null,
  minEditDate: null,
};


const timesheetApprovals = (state = initialState, action) => {
  switch (action.type) {
    case types.SELECT_TIMESHEET_KEY: {
      const { currentTimesheetKey, currentTimesheetIsApproved } = action;
      return {
        ...state,
        currentTimesheetKey,
        currentTimesheetIsApproved,
        currentTimesheetForUserId: parseTimesheetKeyforUserId(currentTimesheetKey),
        currentTimesheetDate: parseTimesheetKeyforDate(currentTimesheetKey),
      };
    }
    case types.SELECT_SUPERVISOR_ID: {
      const { currentSupervisorId } = action;
      return {
        ...state,
        currentSupervisorId,
      };
    }
    case types.SHOW_GUARANTEED_TIME_MODAL: {
      const { maybeApprovedTimesheet } = action;
      return {
        ...state,
        showGuaranteedTimeModal: true,
        maybeApprovedTimesheet,
      };
    }
    case types.HIDE_GUARANTEED_TIME_MODAL: {
      return {
        ...state,
        showGuaranteedTimeModal: false,
        maybeApprovedTimesheet: null,
      };
    }
    case types.SHOW_TIMEENTRY_MODAL: {
      const {
        showTimeEntryModal,
        currentTimeEntry,
        modalIsCreateEdit,
        minEditDate,
        maxEditDate,
      } = action;
      return {
        ...state,
        showTimeEntryModal,
        currentTimeEntry,
        modalIsCreateEdit,
        minEditDate,
        maxEditDate,
      };
    }
    case types.HIDE_TIMEENTRY_MODAL: {
      const { showTimeEntryModal } = action;
      return {
        ...state,
        showTimeEntryModal,
      };
    }
    case types.SET_MODAL_API_ERROR_MESSAGE: {
      const { modalAPIErrorMessage } = action;
      return {
        ...state,
        modalAPIErrorMessage,
      };
    }
    case types.SET_DISABLE_APPROVEUNAPPROVE_BUTTON: {
      const { disableApproveUnapproveButtonForId } = action;
      let disableApproveUnapproveButton = false;

      if (disableApproveUnapproveButtonForId) {
        disableApproveUnapproveButton = true;
      }

      return {
        ...state,
        disableApproveUnapproveButtonForId,
        disableApproveUnapproveButton,
      };
    }
    default:
      return state;
  }
};


export default timesheetApprovals;
